<!-- Mobile Header -->
@if (isMobile$ | async) {
  <div class="sidebar-mobile-header">
    @if (showMobileLocationSwitcher) {
      <div class="sidebar-mobile-header__location-anchor">
        <button type="button"
          class="sidebar-mobile-header__location-btn"
          aria-label="Change location"
          data-testid="mobile-header-location"
          [attr.aria-expanded]="isMobileAccountOpen"
          (click)="toggleMobileAccount()">
          <img class="sidebar-mobile-header__location-pin"
            src="assets/img/location-pin-icon.svg"
            alt=""
            aria-hidden="true">
          <span class="sidebar-mobile-header__location-number"
            [attr.data-testid]="(selectedLocation$ | async)?.locationNumber + '-number'">
            {{ (selectedLocation$ | async)?.locationNumber }}
          </span>
        </button>
      </div>
    }
    <div class="sidebar-mobile-header__main-row">
      <button
        type="button"
        class="sidebar-mobile-header__menu-btn"
        (click)="toggleMobileMenu()"
        [attr.aria-label]="isMobileMenuOpen ? 'Close menu' : 'Open menu'">
        <mat-icon>{{ isMobileMenuOpen ? 'close' : 'menu' }}</mat-icon>
      </button>
      <a class="sidebar-mobile-header__logo"
        routerLink="/"
        data-testid="mobile-sidenav-logo"
        (click)="onMobileLogoClick()">
        <img
          alt="Chick-fil-A Logo"
          class="sidebar-mobile-header__logo-icon"
          src="/assets/img/cfa-logo.png">
          <span class="sidebar-mobile-header__logo-text">Spotlight</span>
        </a>
        <button
          type="button"
          class="sidebar-mobile-header__profile-btn"
          aria-label="User account"
          [attr.aria-expanded]="isMobileAccountOpen"
          data-testid="user-account-menu-trigger-mobile"
          (click)="toggleMobileAccount()">
        <span class="sidebar-mobile-header__profile-avatar">
          <img class="sidebar-mobile-header__profile-icon"
            src="assets/img/profile-avatar-icon.svg"
            alt=""
            aria-hidden="true">
        </span>
      </button>
    </div>
  </div>
  <!-- Mobile Account Menu -->
  <div class="sidebar-mobile-account"
    [class.open]="isMobileAccountOpen"
    [attr.aria-hidden]="!isMobileAccountOpen"
    data-testid="mobile-account-menu">
    <div class="sidebar-mobile-account__header">
      <button type="button"
        class="sidebar-mobile-account__back"
        (click)="closeMobileAccount()"
        aria-label="Back"
        data-testid="mobile-account-back-button">
        <mat-icon>chevron_left</mat-icon>
      </button>
    </div>
    <div class="sidebar-mobile-account__content">
      @if (showMobileLocationSwitcher) {
        <section class="sidebar-mobile-account__location-card"
          data-testid="mobile-location-switcher-section">
        <h2 class="sidebar-mobile-account__location-title">Change Location</h2>
        <location-switcher variant="mobile"></location-switcher>
      </section>
      }
      <nav class="sidebar-mobile-account__menu" aria-label="Account menu">
        <button type="button"
          class="sidebar-mobile-account__menu-item"
          (click)="openSettings()">
          <mat-icon class="sidebar-mobile-account__menu-icon">settings</mat-icon>
          <span class="sidebar-mobile-account__menu-label">Dashboard Layout</span>
          <mat-icon class="sidebar-mobile-account__menu-chevron">chevron_right</mat-icon>
        </button>
        <button type="button"
          class="sidebar-mobile-account__menu-item"
          (click)="openNotifications()">
          <mat-icon class="sidebar-mobile-account__menu-icon">notifications</mat-icon>
          <span class="sidebar-mobile-account__menu-label">
            Notifications
            @if ((unreadNotificationCount$ | async) > 0) {
              <span
                class="sidebar-mobile-account__notification-badge">
                {{ unreadNotificationCount$ | async }} new
              </span>
            }
          </span>
          <mat-icon class="sidebar-mobile-account__menu-chevron">chevron_right</mat-icon>
        </button>
        <button type="button"
          class="sidebar-mobile-account__menu-item"
          (click)="openGiveFeedback()">
          <mat-icon class="sidebar-mobile-account__menu-icon">campaign</mat-icon>
          <span class="sidebar-mobile-account__menu-label">Give Feedback</span>
          <mat-icon class="sidebar-mobile-account__menu-chevron">chevron_right</mat-icon>
        </button>
        <button type="button"
          class="sidebar-mobile-account__menu-item"
          (click)="logoutUser()">
          <mat-icon class="sidebar-mobile-account__menu-icon">exit_to_app</mat-icon>
          <span class="sidebar-mobile-account__menu-label">Logout</span>
          <mat-icon class="sidebar-mobile-account__menu-chevron">chevron_right</mat-icon>
        </button>
      </nav>
    </div>
  </div>
  <!-- Mobile Dropdown Menu -->
  <div class="sidebar-mobile-dropdown" [class.open]="isMobileMenuOpen">
    <div class="sidebar-mobile-dropdown__content">
      @for (link of navLinks; track link.url; let i = $index) {
        <div
          class="sidebar-mobile-dropdown__nav-item"
          [class.expanded]="link.expanded">
          <!-- Nav item with submenu -->
          @if (link.hasSubmenu) {
            <button type="button"
              class="sidebar-mobile-dropdown__nav-item-content cfa-plain-button"
              (click)="onMobileNavItemClick(link, i)"
             >
              <div class="sidebar-mobile-dropdown__nav-item-left">
                <mat-icon class="sidebar-mobile-dropdown__nav-icon" [svgIcon]="'cfa-' + link.icon"></mat-icon>
                <span class="sidebar-mobile-dropdown__nav-label">{{ link.label }}</span>
              </div>
              <mat-icon
                class="sidebar-mobile-dropdown__nav-arrow"
                [svgIcon]="link.expanded ? 'cfa-chevron-up' : 'cfa-chevron-down'">
              </mat-icon>
            </button>
          } @else {
            <sidebar-nav-link
              [link]="link"
              [locationNumber]="selectedLocationNumber"
              variant="mobile"
              (linkClick)="onMobileNavItemClick(link, i)">
            </sidebar-nav-link>
          }
          <!-- Nav item without submenu -->
          <!-- Submenu -->
          @if (link.hasSubmenu && link.expanded) {
            <div
              class="sidebar-mobile-dropdown__submenu">
              @for (subItem of link.submenuItems; track subItem.url + '|' + subItem.label + '|' + (subItem.queryParams?.index ?? subItem.queryParams?.engagementIndex ?? '')) {
                <a
                  class="sidebar-mobile-dropdown__submenu-item"
                  [routerLink]="locationScopedUrl(subItem.url)"
                  [queryParams]="subItem.queryParams"
                  routerLinkActive
                  [routerLinkActiveOptions]="{ exact: true }"
                  #mobileSubmenuRla="routerLinkActive"
                  [class.active]="isMeetAnalyticsSubmenuActive(subItem, mobileSubmenuRla.isActive)"
                  (click)="closeMobileMenu()">
                  {{ subItem.label }}
                </a>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
  <!-- Overlay to close menu when clicking outside -->
  <button type="button"
    class="sidebar-mobile-overlay cfa-plain-button"
    [class.open]="isMobileMenuOpen || isMobileAccountOpen"
    (click)="closeMobileOverlays()"
    aria-label="Close menu">
  </button>
}

<!-- Desktop Sidebar -->
@if (!(isMobile$ | async)) {
  <nav class="sidebar" aria-label="Main menu" [class.collapsed]="isCollapsed">
    <!-- Logo Section -->
    <div class="sidebar__logo-section">
      <a class="sidebar__logo" routerLink="/">
        <img
          alt="Chick-fil-A Logo"
          class="sidebar__logo-icon"
          src="/assets/img/cfa-logo.png">
          @if (!isCollapsed) {
            <span class="sidebar__logo-text">Spotlight</span>
          }
        </a>
      </div>
      <!-- Collapse Toggle Button -->
      <div class="sidebar__toggle" [class.collapsed]="isCollapsed">
        <button
          type="button"
          class="sidebar__toggle-button"
          (click)="toggleSidebar()"
          [attr.aria-label]="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'">
        <mat-icon class="sidebar__toggle-arrow" [svgIcon]="isCollapsed ? 'cfa-chevron-right' : 'cfa-chevron-left'"></mat-icon>
      </button>
    </div>
    <!-- Divider -->
    <hr class="sidebar__divider">
    <!-- Navigation Items -->
    <div class="sidebar__nav">
      @for (link of navLinks; track link.url; let i = $index) {
        <div
          class="sidebar__nav-item"
          [class.expanded]="link.expanded">
          <!-- Nav item with submenu -->
          @if (link.hasSubmenu) {
            <button type="button"
              class="sidebar__nav-item-content cfa-plain-button"
              (click)="onNavItemClick(link, i)"
              [matTooltip]="isCollapsed ? link.label : ''"
              matTooltipPosition="right"
             >
              <div class="sidebar__nav-item-left">
                <mat-icon class="sidebar__nav-icon" [svgIcon]="'cfa-' + link.icon"></mat-icon>
                @if (!isCollapsed) {
                  <span class="sidebar__nav-label">{{ link.label }}</span>
                }
              </div>
              @if (!isCollapsed) {
                <mat-icon
                  class="sidebar__nav-arrow"
                  [svgIcon]="link.expanded ? 'cfa-chevron-up' : 'cfa-chevron-down'">
                </mat-icon>
              }
            </button>
          } @else {
            <sidebar-nav-link
              [link]="link"
              [locationNumber]="selectedLocationNumber"
              variant="desktop"
              [showLabel]="!isCollapsed"
              [showTooltip]="isCollapsed"
              [tooltipText]="link.label"
              tooltipPosition="right"
              (linkClick)="onNavItemClick(link, i)">
            </sidebar-nav-link>
          }
          <!-- Nav item without submenu -->
          <!-- Submenu -->
          @if (link.hasSubmenu && link.expanded && !isCollapsed) {
            <div
              class="sidebar__submenu">
              @for (subItem of link.submenuItems; track subItem.url + '|' + subItem.label + '|' + (subItem.queryParams?.index ?? subItem.queryParams?.engagementIndex ?? '')) {
                <a
                  class="sidebar__submenu-item"
                  [routerLink]="locationScopedUrl(subItem.url)"
                  [queryParams]="subItem.queryParams"
                  routerLinkActive
                  [routerLinkActiveOptions]="{ exact: true }"
                  #desktopSubmenuRla="routerLinkActive"
                  [class.active]="isMeetAnalyticsSubmenuActive(subItem, desktopSubmenuRla.isActive)"
                  (click)="onSubmenuItemClick(subItem, i)">
                  {{ subItem.label }}
                </a>
              }
            </div>
          }
        </div>
      }
    </div>
  </nav>
}

